export const STEP_X = 22.8;

export const MAX_TICK_LENGTH = 26;

export const TICK_PADDING_RIGHT = 4;

export const ALLOWED_ANCHORS = ['inherit', 'end', 'start', 'middle'] as const;
